import React from "react";
import { Checkbox } from "@dhis2/ui-core";

const SelectCell = props => (
  <td class="cell-leading-icon cell-checkbox">
    <Checkbox dense />
  </td>
);

export default SelectCell;
